import { useMemo, memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import MainSelect from '@UI/MainSelect';
import Variant from '../Variant';
import styles from './StepPeoples.module.css';

import type { VariantData, Parameter } from '@Pages/PageQuizMattrasses/typings';
import type { HTMLAttributes, FC, MouseEvent, MutableRefObject } from 'react';
import type { SelectItemData } from '@divlab/divanui';

export interface StepPeoplesProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> {
  className?: string;
  variants: VariantData[];
  parameter: Parameter;
  refSizes?: MutableRefObject<HTMLDivElement>;
  onSelect?: (e: MouseEvent, variant: VariantData) => void;
  onChangeSize?: (e: MouseEvent, items: SelectItemData[]) => void;
}

const StepPeoples: FC<StepPeoplesProps> = (props) => {
  const { className, variants, parameter, refSizes, onSelect, onChangeSize, ...restProps } = props;
  const selectedVariant = variants.find((variant) => variant.selected);
  const { t } = useTranslation();

  const items = useMemo(() => {
    const allItems = [];

    (parameter.width || []).forEach((widthOption) => {
      (parameter.height || []).forEach((heightOption) => {
        //убираем не существующий размер
        if (widthOption.value === 90 && heightOption.value === 190) return;
        const title = `${widthOption.text} x ${heightOption.text} ${t('ui.sm')}`;

        allItems.push({
          id: title,
          title,
          name: title,
          selected: widthOption.selected && heightOption.selected,
          data: {
            width: widthOption.value,
            height: heightOption.value,
          },
        });
      });
    });

    return allItems;
  }, [parameter.height, parameter.width, t]);

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.variantsWrapper}>
        {variants.map((variant) => (
          <Variant
            data-testid='mattrass-for'
            className={styles.variant}
            key={variant.id}
            variant={variant}
            onSelect={onSelect}
          />
        ))}
      </div>
      <div className={styles.textWrapper} ref={refSizes}>
        <div className={styles.text}>{t('step-people-text')}</div>
      </div>
      <MainSelect
        wide
        clickableContainerTestId='mattrass-size'
        key={selectedVariant?.id}
        bordered={false}
        className={styles.select}
        items={items}
        onChangeSelected={onChangeSize}
      />
    </div>
  );
};

export default memo(StepPeoples);
